export default "__VITE_ASSET__Cpqik_IC__"